import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	shareTitle: {
		id: 'business-list.list-view.header-actions.share-title',
		defaultMessage: 'List',
		description:
			'Name of the entity type that is going to be shared to others, this will be used as email title for the share recipients',
	},
	simpleSearch: {
		id: 'business-list.list-view.header-actions.simple-search',
		defaultMessage: 'Search list',
		description:
			'Placeholder of the text field above the list that allows the user to search by text through the list',
	},
	searchLabel: {
		id: 'business-list.list-view.header-actions.search-label',
		defaultMessage: 'Typing letters in the search input applies filters',
		description:
			'Label for the text field notifying users that typing letters on the search field would filter the results.',
	},
	format: {
		// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
		id: 'business-list.list-view.header-actions.conditional-formatting',
		defaultMessage: 'Format',
		description: 'Label for format rules button to open the format rules sidebar',
	},
});
